import type { FC } from "react";

import { cn, makeBreakpointClassName } from "@/ui/lib/utils";
import {
  BASE_TEXT_SUBTITLE_SIZE_CLASS_MAP,
  RESPONSIVE_TEXT_SUBTITLE_SIZE_CLASS_MAP,
  TEXT_SUBTITLE_DEFAULTS,
  TTextSubtitleProps,
} from "@/ui/components/typography/TextSubtitle/TextSubtitle.config";
import {
  TYPOGRAPHY_COLORS_CLASS_MAP,
  TYPOGRAPHY_RESPONSIVE_ALIGNMENTS_CLASS_MAP,
  TYPOGRAPHY_WHITESPACES_CLASS_MAP,
} from "@/ui/components/typography/typography.config";

export const TextSubtitle: FC<TTextSubtitleProps> = (
  {
    tag: Tag = TEXT_SUBTITLE_DEFAULTS.tag,
    size = TEXT_SUBTITLE_DEFAULTS.size,
    color = TEXT_SUBTITLE_DEFAULTS.color,
    align = TEXT_SUBTITLE_DEFAULTS.align,
    whitespace = TEXT_SUBTITLE_DEFAULTS.whitespace,
    isResponsive = TEXT_SUBTITLE_DEFAULTS.isResponsive,
    children,
    className,
    ...props
  },
) => (
  <Tag
    {...props}
    data-component="TextSubtitle"
    className={cn(
      "font-sys-display",
      "font-bold",
      "tracking-sys-tight",
      "leading-sys-1",
      makeBreakpointClassName(align, TYPOGRAPHY_RESPONSIVE_ALIGNMENTS_CLASS_MAP, "left"),
      TYPOGRAPHY_WHITESPACES_CLASS_MAP[whitespace],
      TYPOGRAPHY_COLORS_CLASS_MAP[color],
      isResponsive ?
        RESPONSIVE_TEXT_SUBTITLE_SIZE_CLASS_MAP[size] :
        BASE_TEXT_SUBTITLE_SIZE_CLASS_MAP[size],
      className,
    )
    }
  >
    { children }
  </Tag>
);

TextSubtitle.displayName = "TextSubtitle";
